import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { PulseLoader } from 'react-spinners';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

import { ModelOfProduct } from 'src/database';
import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import { useListProductsController } from '../../controllers/Products/ListProductsController';
import { useFormCreateProducts } from 'src/controllers/Products/CreateProductsController';
import { useData } from 'src/contexts/data';

import DropzoneScreen from 'src/components/Dropzone/Dropzone';
import LoadingScreen from '../../components/LoadingScreen';

const ProductsList: React.FC = () => {
    const { getProductListController, handleProductListController } = useListProductsController();
    const { getController } = useFormCreateProducts();
    const { getImages } = useData();

    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    if (getProductListController.loading) {
        return <LoadingScreen />
    };





    const brands = getController.tablesData.brandsData.map((brand) => {
        return { label: brand.DESCRICAO, value: brand.ID }
    }
    );
    const groups = getController.tablesData.groupsData.map((group) => {
        return { label: group.DESCRICAO, value: group.ID }
    }
    );
    const subgroups = getController.tablesData.subgroupsData.map((subgroup) => {
        return { label: subgroup.DESCRICAO, value: subgroup.ID }
    }
    );

    const tableHeader = (
        <div className="table-header p-grid p-d-flex p-jc-between">
            <h5 className="p-m-0">Produtos</h5>
            <span className="p-input-icon-left p-search-bar">
                <i className="pi pi-search" />
                <InputText type="search" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const actionBodyTemplate = (Product: ModelOfProduct) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success" onClick={() => handleProductListController.openEditDialog(Product)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleProductListController.openDeleteDialog(Product)} />
            </React.Fragment>
        );
    };

    const editProductDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleProductListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getProductListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleProductListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getProductListController.selectedProduct && handleProductListController.removeProduct(getProductListController.selectedProduct)
                }}
            />
        </React.Fragment>
    );

    const leftProductToolbar = () => {
        return (
            <Link to="/productForm">
                <Button label="Cadastrar produto" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    const HEADER_DESCRICAO = (rowData: ModelOfProduct) => {
        return (
            <React.Fragment>
                <span className="left-header">DESCRICAO</span>
                {rowData.DESCRICAO}
            </React.Fragment>
        );
    }

    const HEADER_DESCRICAOCOMPLETA = (rowData: ModelOfProduct) => {
        return (
            <React.Fragment>
                <span className="left-header">DESCRICAO COMPLETA</span>
                {rowData.DESCRICAOCOMPLETA}
            </React.Fragment>
        );
    }

    const HEADER_MARCA_DESCRICAO = (rowData: ModelOfProduct) => {
        return (
            <React.Fragment>
                <span className="left-header">MARCA</span>
                {rowData.MARCA_DESCRICAO}
            </React.Fragment>
        );
    }

    const HEADER_NCM = (rowData: ModelOfProduct) => {
        return (
            <React.Fragment>
                <span className="left-header">NCM</span>
                {rowData.NCM}
            </React.Fragment>
        );
    }

    const HEADER_ULTIMOVALORCOMPRA = (rowData: ModelOfProduct) => {
        const valorFormatado = Number(rowData.ULTIMOVALORCOMPRA).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        return (
            <React.Fragment>
                <span className="left-header">ULTIMO VALOR DE COMPRA</span>
                {valorFormatado}
            </React.Fragment>
        );
    };

    const HEADER_ULTIMOVALORVENDA = (rowData: ModelOfProduct) => {
        const valorFormatado = Number(rowData.ULTIMOVALORVENDA).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        return (
            <React.Fragment>
                <span className="left-header">ULTIMO VALOR DE VENDA</span>
                {valorFormatado}
            </React.Fragment>
        );
    }

    const HEADER_CODIGOBARRAS = (rowData: ModelOfProduct) => {
        return (
            <React.Fragment>
                <span className="left-header">CODIGO DE BARRAS</span>
                {rowData.CODIGOBARRAS}
            </React.Fragment>
        );
    }

    const HEADER_GRUPO_DESCRICAO = (rowData: ModelOfProduct) => {
        return (
            <React.Fragment>
                <span className="left-header">GRUPO</span>
                {rowData.GRUPO_DESCRICAO}
            </React.Fragment>
        );
    }

    const HEADER_SUBGRUPO_DESCRICAO = (rowData: ModelOfProduct) => {
        return (
            <React.Fragment>
                <span className="left-header">SUBGRUPO</span>
                {rowData.SUBGRUPO_DESCRICAO}
            </React.Fragment>
        );
    }

    const Loader: React.FC = ({ children }) => {
        const divRef: any = useRef<HTMLDivElement | null>(null);

        const [isVisible] = useIntersectionObserver({
            elementRef: divRef,
        });

        if (isVisible && !getProductListController.maxData && !getProductListController.loadingRows) {
            handleProductListController.setRows(getProductListController.rows + 20);
        };

        return (
            <div
                ref={divRef}
                style={{
                    minHeight: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {children}
            </div>
        )
    }

    return (
        <div>
            <Toast ref={getProductListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftProductToolbar}></Toolbar>

                <DataTable
                    header={tableHeader}
                    globalFilter={globalFilter} rowHover
                    className="responsive-table p-datatable-sm"
                    dataKey="ID" 
                    value={getProductListController.productsData}
                >
                    <Column field="DESCRICAO" header="DESCRIÇÃO" body={HEADER_DESCRICAO}></Column>
                    <Column field="DESCRICAOCOMPLETA" header="DESCRIÇÃO COMPLETA" body={HEADER_DESCRICAOCOMPLETA}></Column>
                    <Column field="MARCA_DESCRICAO" header="MARCA" body={HEADER_MARCA_DESCRICAO}></Column>
                    <Column field="NCM" header="NCM" body={HEADER_NCM}></Column>
                    <Column field="ULTIMOVALORCOMPRA" header="ULTIMO VALOR DE COMPRA" body={HEADER_ULTIMOVALORCOMPRA} bodyStyle={{ textAlign: 'right' }}></Column>
                    <Column field="ULTIMOVALORVENDA" header="ULTIMO VALOR DE VENDA" body={HEADER_ULTIMOVALORVENDA} bodyStyle={{ textAlign: 'right' }}></Column>
                    <Column field="CODIGOBARRAS" header="CODIGO DE BARRAS" body={HEADER_CODIGOBARRAS}></Column>
                    <Column field="GRUPO_DESCRICAO" header="GRUPO" body={HEADER_GRUPO_DESCRICAO}></Column>
                    <Column field="SUBGRUPO_DESCRICAO" header="SUBGRUPO" body={HEADER_SUBGRUPO_DESCRICAO}></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
                <Loader>{!getProductListController.maxData ?
                    getProductListController.loadingRows ? <PulseLoader color="#0388e5" size={8} /> : <></>
                    : "Lista completa"}
                </Loader>
            </div>

            <Dialog
                className="p-fluid"
                style={{ width: '90%' }}
                visible={getProductListController.editDialog}
                onHide={handleProductListController.closeEditDialog}
                onShow={() => {
                    getProductListController.formik.setValues(getProductListController.selectedProduct)
                    getImages(getProductListController.selectedProduct.ID);
                }}
                footer={editProductDialogFooter}
                header={`Editar produto ${getProductListController.selectedProduct?.DESCRICAO}`}
                modal
            >
                {getProductListController.loadingEdit ? <LoadingScreen color="#0388e5" /> : <></>}
                <div className="p-grid p-fluid">
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="descricao" >Descrição</label>
                        <InputText id="descricao" maxLength={150}
                            {...getProductListController.formik.getFieldProps('DESCRICAO')}
                            onChange={getProductListController.formik.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductListController.formik.touched.DESCRICAO && getProductListController.formik.errors.DESCRICAO,
                            'popup-form-inactive': !(getProductListController.formik.touched.DESCRICAO && getProductListController.formik.errors.DESCRICAO),
                        })}
                        >{getProductListController.formik.errors.DESCRICAO}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="marca" >Marca</label>
                        <Dropdown id="marca"
                            options={brands}
                            value={getProductListController.formik.values.MARCA}
                            onChange={(e) => getProductListController.formik.setFieldValue('MARCA', e.value)}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductListController.formik.touched.MARCA && getProductListController.formik.errors.MARCA,
                            'popup-form-inactive': !(getProductListController.formik.touched.MARCA && getProductListController.formik.errors.MARCA),
                        })}
                        >{getProductListController.formik.errors.MARCA}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="descricaoComp" >Descrição completa</label>
                        <InputTextarea rows={6} autoResize id="descricaoComp" maxLength={500}
                            {...getProductListController.formik.getFieldProps('DESCRICAOCOMPLETA')}
                            onChange={getProductListController.formik.handleChange('DESCRICAOCOMPLETA')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductListController.formik.touched.DESCRICAOCOMPLETA && getProductListController.formik.errors.DESCRICAOCOMPLETA,
                            'popup-form-inactive': !(getProductListController.formik.touched.DESCRICAOCOMPLETA && getProductListController.formik.errors.DESCRICAOCOMPLETA),
                        })}
                        >{getProductListController.formik.errors.DESCRICAOCOMPLETA}</div>
                    </div>

                    <div className="p-grid p-col-12 p-md-6">
                        <div className="p-field p-col-12">
                            <label htmlFor="codBarras" >Código de barras</label>
                            <InputText id="codBarras" maxLength={100}
                                {...getProductListController.formik.getFieldProps('CODIGOBARRAS')}
                                onChange={getProductListController.formik.handleChange('CODIGOBARRAS')}
                            />
                            <div className={classNames("p-invalid popup-fade", {
                                'popup-form-active': getProductListController.formik.touched.CODIGOBARRAS && getProductListController.formik.errors.CODIGOBARRAS,
                                'popup-form-inactive': !(getProductListController.formik.touched.CODIGOBARRAS && getProductListController.formik.errors.CODIGOBARRAS),
                            })}
                            >{getProductListController.formik.errors.CODIGOBARRAS}</div>
                        </div>

                        <div className="p-field p-col-12">
                            <label htmlFor="ncm" >NCM</label>
                            <InputText id="ncm" maxLength={20}
                                {...getProductListController.formik.getFieldProps('NCM')}
                                onChange={getProductListController.formik.handleChange('NCM')}
                            />
                            <div className={classNames("p-invalid popup-fade", {
                                'popup-form-active': getProductListController.formik.touched.NCM && getProductListController.formik.errors.NCM,
                                'popup-form-inactive': !(getProductListController.formik.touched.NCM && getProductListController.formik.errors.NCM),
                            })}
                            >{getProductListController.formik.errors.NCM}</div>
                        </div>
                    </div>

                    <div className="p-field p-col-6 p-md-3">
                        <label htmlFor="grupo" >Grupo</label>
                        <Dropdown id="grupo"
                            options={groups}
                            value={getProductListController.formik.values.AX_GRUPO}
                            onChange={(e) => getProductListController.formik.setFieldValue('AX_GRUPO', e.value)}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductListController.formik.touched.AX_GRUPO && getProductListController.formik.errors.AX_GRUPO,
                            'popup-form-inactive': !(getProductListController.formik.touched.AX_GRUPO && getProductListController.formik.errors.AX_GRUPO),
                        })}
                        >{getProductListController.formik.errors.AX_GRUPO}</div>
                    </div>

                    <div className="p-field p-col-6 p-md-3">
                        <label htmlFor="subgrupo" >Subgrupo</label>
                        <Dropdown id="subgrupo"
                            options={subgroups}
                            value={getProductListController.formik.values.AX_GRUPOSUB}
                            onChange={(e) => getProductListController.formik.setFieldValue('AX_GRUPOSUB', e.value)}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductListController.formik.touched.AX_GRUPOSUB && getProductListController.formik.errors.AX_GRUPOSUB,
                            'popup-form-inactive': !(getProductListController.formik.touched.AX_GRUPOSUB && getProductListController.formik.errors.AX_GRUPOSUB),
                        })}
                        >{getProductListController.formik.errors.AX_GRUPOSUB}</div>
                    </div>

                    <div className="p-field p-col-6 p-md-3">
                        <label htmlFor="ultCompra">Último valor de compra</label>
                        <InputNumber id="ultCompra"
                            {...getProductListController.formik.getFieldProps('ULTIMOVALORCOMPRA')}
                            onChange={(e) => getProductListController.formik.setFieldValue('ULTIMOVALORCOMPRA', e.value)}
                            mode="currency" currency="BRL" locale="pt-BR"
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductListController.formik.touched.ULTIMOVALORCOMPRA && getProductListController.formik.errors.ULTIMOVALORCOMPRA,
                            'popup-form-inactive': !(getProductListController.formik.touched.ULTIMOVALORCOMPRA && getProductListController.formik.errors.ULTIMOVALORCOMPRA),
                        })}
                        >{getProductListController.formik.errors.ULTIMOVALORCOMPRA}</div>
                    </div>

                    <div className="p-field p-col-6 p-md-3">
                        <label htmlFor="ultVenda">Último valor de venda</label>
                        <InputNumber id="ultVenda"
                            {...getProductListController.formik.getFieldProps('ULTIMOVALORVENDA')}
                            onChange={(e) => getProductListController.formik.setFieldValue('ULTIMOVALORVENDA', e.value)}
                            mode="currency" currency="BRL" locale="pt-BR"
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductListController.formik.touched.ULTIMOVALORVENDA && getProductListController.formik.errors.ULTIMOVALORVENDA,
                            'popup-form-inactive': !(getProductListController.formik.touched.ULTIMOVALORVENDA && getProductListController.formik.errors.ULTIMOVALORVENDA),
                        })}
                        >{getProductListController.formik.errors.ULTIMOVALORVENDA}</div>
                    </div>

                    <div className="p-field p-col-12">
                        <label htmlFor="ultVenda">Foto do produto</label>
                        <div className="p-fileupload">
                            <DropzoneScreen />
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getProductListController.deleteDialog}
                onHide={handleProductListController.closeDeleteDialog}
                footer={deleteProductDialogFooter}
                header="Remover marca"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getProductListController.selectedProduct && <span>Você tem certeza que deseja remover <b>{getProductListController.selectedProduct.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default ProductsList;